/**
 * For phones, we want to prevent the user from moving the Chat
 * Interface at all.  This includes scrolling the page.  So, we're
 * going to repurpose the IDragResize object to ensure that 
 * touchstart and touchmove events get swallowed here.
 */
/**
 * package: com.inq.stage
 * class: Immovable
 * @extends com.inq.stage.DragResize 
 * @constructor
 */
com.inq.stage.Immovable = function() {
	com.inq.stage.DragResize.call(this);
	this.className = "Immovable";
	this.cursor = "";
};
$hxClasses['com.inq.stage.Immovable'] = com.inq.stage.Immovable;
/** @private @type {Array} */
com.inq.stage.Immovable.__name__ = ["com","inq","stage","Immovable"];
/** @private @type {Function} */
com.inq.stage.Immovable.__super__ = com.inq.stage.DragResize;
for(var k in com.inq.stage.DragResize.prototype ) com.inq.stage.Immovable.prototype[k] = com.inq.stage.DragResize.prototype[k];

/**
 * MakeImmovable
 * Replaces the "FlashPeer.setDragable
 * Sets up the chat skin for being moved around and replaces the version in the IJSF
 *
 * $type TFun([],TInst(com.inq.stage.Immovable,[]))
 * public static function MakeImmovable():Immovable
 * @public
 * @static
 * @return {com.inq.stage.Immovable}
 */
com.inq.stage.Immovable.MakeImmovable = function() {
	/** @type {com.inq.stage.Immovable} */
	var instance = new com.inq.stage.Immovable();
	/** @type {Element} */
	var pDoc = window.parent.document;
	var cntr = com.inq.ui.Container._getElementById("inqChatStage",pDoc);
	/** @type {Element} */
	var dragHandleElem = com.inq.ui.Container._getElementById("inqTitleBar",pDoc);
	instance.init(dragHandleElem,cntr);
	
	return instance;
};


/**
 * immobilize
 *
 * $type TFun([{ name => node, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public static function immobilize(node:Dynamic):Void
 * @public
 * @static
 * @param {null}  node 
 * @return {void}
 */
com.inq.stage.Immovable.immobilize = function(node) {
	com.inq.utils.Capabilities.BindListener(node,"touchmove",com.inq.stage.DragResize.stopEvent);
};


/**
 * whenDone is invoked following the mouse up event in uponDrop function
 * It is invoked via the setTimeout functiona and is NOT in the same thread as the
 * event handler.  This is by design so not to delay further event handling.
 *
 * $type TFun([],TEnum(Void,[]))
 * override public function whenDone ():Void
 * @override
 * @public
 * @this com.inq.stage.Immovable
 * @return {void}
 */
com.inq.stage.Immovable.prototype.whenDone = function() {
};


/**
 * uponDragStart
 * Override DragResize so that dragging the target element does
 * NOTHING, not even scroll the page.
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponDragStart(e:Dynamic):Bool
 * @override
 * @private
 * @this com.inq.stage.Immovable
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.Immovable.prototype.uponDragStart = function(e) {
	return com.inq.stage.DragResize.stopEvent(e);
};


/**
 * uponTouchEnd
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponTouchEnd(e:Dynamic):Bool
 * @override
 * @private
 * @this com.inq.stage.Immovable
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.Immovable.prototype.uponTouchEnd = function(e) {
	return com.inq.stage.DragResize.stopEvent(e);
};


/**
 * uponDrop
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponDrop(e:Dynamic):Bool
 * @override
 * @private
 * @this com.inq.stage.Immovable
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.Immovable.prototype.uponDrop = function(e) {
	return com.inq.stage.DragResize.stopEvent(e);
};


/**
 * uponMouseOut
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponMouseOut(e:Dynamic):Bool
 * @override
 * @private
 * @this com.inq.stage.Immovable
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.Immovable.prototype.uponMouseOut = function(e) {
	return com.inq.stage.DragResize.stopEvent(e);
};


/**
 * uponTouchCancel
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponTouchCancel(e:Dynamic):Bool
 * @override
 * @private
 * @this com.inq.stage.Immovable
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.Immovable.prototype.uponTouchCancel = function(e) {
	return com.inq.stage.DragResize.stopEvent(e);
};


/**
 * uponTouchDrag
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponTouchDrag(e:Dynamic):Bool
 * @override
 * @private
 * @this com.inq.stage.Immovable
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.Immovable.prototype.uponTouchDrag = function(e) {
	return com.inq.stage.DragResize.stopEvent(e);
};


/**
 * uponDrag
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponDrag(e:Dynamic):Bool
 * @override
 * @private
 * @this com.inq.stage.Immovable
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.Immovable.prototype.uponDrag = function(e) {
	return com.inq.stage.DragResize.stopEvent(e);
};


/**
 * uponTouchStart
 * Ensure that tapping/touching the target element does NOTHING.
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * override private function uponTouchStart(e:Dynamic):Bool
 * @override
 * @private
 * @this com.inq.stage.Immovable
 * @param {null}  e 
 * @return {boolean}
 */
com.inq.stage.Immovable.prototype.uponTouchStart = function(e) {
	return com.inq.stage.DragResize.stopEvent(e);
};

/** @type {com.inq.stage.Immovable} */
com.inq.stage.Immovable.prototype.__class__ = com.inq.stage.Immovable;
com.inq.stage.Immovable.__interfaces__ = [com.inq.stage.IDragResize];
